/**
 * Позиции слайдов ПК. Только transform, без логики скролла.
 * 0→1 PC1 влево, PC2 справа; 1→2 PC2→PC3; 2→3 PC3→PC4; 3→4 PC4→работы; 4→5 кнопки работ.
 */

function applyPcPositions(panels, progress) {
    const { pc1, pc2, pc3, pc4, latestWorks } = panels;
    const p1 = Math.min(progress, 1);
    const p2 = Math.min(Math.max(progress - 1, 0), 1);
    const p3 = Math.min(Math.max(progress - 2, 0), 1);
    const p4 = Math.min(Math.max(progress - 3, 0), 1);
    const p5 = Math.min(Math.max(progress - 4, 0), 1);
    const fade = p5 * p5 * (3 - 2 * p5);
    pc1.style.transform = `translate3d(${-p1 * 100}vw,0,0)`;
    pc2.style.transform = `translate3d(calc(-50% + ${(1 - p1 - p2) * 100}vw),0,0)`;
    pc3.style.transform = `translate3d(calc(-50% + ${(1 - p2 - p3) * 100}vw),0,0)`;
    pc4.style.transform = `translate3d(calc(-50% + ${(1 - p3 - p4) * 100}vw),0,0)`;
    latestWorks.style.transform = `translate3d(calc(-50% + ${(1 - p4) * 100}vw),0,0)`;
    latestWorks.style.setProperty("--works-btn-fade", fade.toFixed(4));
    latestWorks.classList.toggle("latest-works-block_all", fade > 0.5);
}

export default applyPcPositions;
// hooks/pcScroll/applyPcPositions.js
